import { render } from "./NotesDrawer.vue?vue&type=template&id=4a11a2d3"
import script from "./NotesDrawer.vue?vue&type=script&lang=js"
export * from "./NotesDrawer.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__